import React from 'react';

const Footer = () => {
    return (
        <div className='footer'>
            <div className="footer-content footer-quotes">"Believe you can and you're halfway there" - Theodore Roosevelt</div>
            <div className="footer-content footer-copyright">© 2022 Suman Bista | All Rights Reserved</div>
        </div>
    );
}

export default Footer;
